var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"cols":"10"}},[_vm._v("\n    "+_vm._s(_vm.description)+"\n  ")]),_c('b-col',[_c('b-row',[_c('b-col',[_c('b-link',[_vm._v("\n          Website\n        ")])],1)],1),_c('b-row',[_c('b-col',[_c('b-link',[_vm._v("\n          Support\n        ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }